import { render } from "./SensorCard.vue?vue&type=template&id=5fa135d6&scoped=true&ts=true"
import script from "./SensorCard.vue?vue&type=script&lang=ts"
export * from "./SensorCard.vue?vue&type=script&lang=ts"

import "./SensorCard.vue?vue&type=style&index=0&id=5fa135d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa135d6"]])

export default __exports__